import type { Page } from '@autobid/strapi-integration/typescript/strapi/Page'
import type { Enum_Componentsharedaccess_Name } from '../graphql/graphql'

export function removeDynamicPartOfSlug(slug?: string) {
  return slug?.endsWith('/slug') ? slug.replace('/slug', '') : slug
}

/**
 * @description converts given path to the slug
 * @param routePath - current route path without the domain e.g. /en/test-123
 * @returns The object with keys, slug (current slug without the language prefix)
 * and dynamicSlug (if the current route has more than one part, then the last part of path is replaces with a string "slug")
 */
export function getSlugFromUrl(routePath: string, currentLang: string) {
  const result
    = currentLang && routePath.startsWith(`/${currentLang}`)
      ? `${routePath}`.replace(`/${currentLang}`, '')
      : routePath
  let dynamicSlug: string[] | null = null

  const splittedSlug = result.replace('/', '').split('/').filter(Boolean)

  const isSlugDynamic = splittedSlug.length >= 2

  if (isSlugDynamic) {
    /*
      override the dynamic slug part with the "slug" word (the dynamic slug parts in the strapi has a "slug" name)
      e.g. /greencars/slug is gonna match /greencars/article-1, /greencars/article-2, /greencars/any-string etc.
    */
    dynamicSlug = [...splittedSlug]
    dynamicSlug[dynamicSlug.length - 1] = 'slug'
  }

  return {
    slug: splittedSlug.length ? splittedSlug.join('/') : '/',
    dynamicSlug: dynamicSlug?.join('/'),
  }
}

/**
 * @description The functions removes the reference from the objects, arrays etc. It's helpful for the situation when you want
to copy a value and modify without modifying the original value
 * @param value - any value
 * @returns a value from the parameters
 */
export function removeReference<T>(value: T) {
  return value === undefined ? value : (JSON.parse(JSON.stringify(value)) as T)
}

export function hasUserAccessToThisPage(pageAccess: NonNullable<Page['access']>['name'] | Enum_Componentsharedaccess_Name | null | undefined, authenticated: boolean) {
  if (!pageAccess) {
    return true
  }

  switch (pageAccess) {
    case 'public':
      return true
    case 'protected':
      return authenticated
    case 'unauthenticated-only':
    case 'unauthenticated_only':
      return !authenticated
    default:
      return true
  }
}
